import dynamic from 'next/dynamic';

// Client-only: react-player/lazy suspends during SSR, which makes hydration of
// this page fail intermittently ("Hydration failed ... Suspense").
const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });

//styles
import {
  OurStoryWrapper,
  HeaderSection,
  Title,
  Description,
  VideoContainer,
  VideoWrapper,
} from './OurStory.styles';

//containers
import { Container } from '@/components/Grid';

export default function OurStory({ content }) {
  return (
    <OurStoryWrapper>
      <Container>
        <HeaderSection>
          <Title>{content.title}</Title>
          <Description>{content.description}</Description>
        </HeaderSection>
      </Container>

      <VideoContainer>
        <VideoWrapper>
          <ReactPlayer
            className="react-player"
            url="https://www.youtube.com/watch?v=2YNy6FevODs?rel=0"
            controls
            width="100%"
            height="100%"
          />
        </VideoWrapper>
      </VideoContainer>
    </OurStoryWrapper>
  );
}

export { OurStory };
